import React from 'react';
import Table from 'react-bootstrap/Table';

import { ECGResults } from '../../../common/types/ECGResults';

interface ECGMetricsTableProps {
  results: ECGResults;
}

export const ECGMetricsTable: React.FC<ECGMetricsTableProps> = ({
  results,
}) => {
  const metrics: Array<{
    label: string;
    value: string | number | number[] | null;
  }> = [
    { label: 'HR', value: results.HR },
    { label: 'PR', value: results.PR },
    { label: 'QTc', value: results.QTc },
    { label: 'QRS', value: results.QRS },
    { label: 'ST', value: results.ST },
    { label: 'PSI', value: results.PSI },
    { label: 'RMSSD', value: results.RMSSD },
    { label: 'SDNN', value: results.SDNN },
    {
      label: 'Płeć',
      value: results.gender
        ? results.gender === 'male'
          ? 'Mężczyzna'
          : 'Kobieta'
        : null,
    },
    { label: 'Jakość sygnału', value: results.goodQuality ? 'Dobra' : 'Zła' },
  ];

  return (
    <Table striped bordered hover responsive className="mt-3">
      <thead>
        <tr>
          <th>Nazwa</th>
          <th>Wartość</th>
        </tr>
      </thead>
      <tbody>
        {metrics
          .filter(
            metric =>
              metric.value !== null &&
              metric.value !== undefined &&
              !(Array.isArray(metric.value) && metric.value.length === 0),
          )
          .map((metric, index) => (
            <tr key={index}>
              <td>{metric.label}</td>
              <td>
                {Array.isArray(metric.value)
                  ? metric.value.join(', ')
                  : String(metric.value)}
              </td>
            </tr>
          ))}
      </tbody>
    </Table>
  );
};
